import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';

/**
 * One setting: the label and an optional description, then the projected
 * control. `inline` puts the control on the right (it wraps under the label
 * when there is no room); `stacked` puts the label above a full-width
 * control. Content marked `[rowBadge]` sits after the label and
 * `[rowDescription]` replaces the plain description. The control sits in its
 * own shadow root, so give it `ariaLabel` equal to the row label.
 */
@Component({
  selector: 'app-settings-row-cabinet',
  templateUrl: './settings-row.component.html',
  styleUrl: './settings-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  host: {
    '[class.settings-row--stacked]': "layout() === 'stacked'",
    '[class.settings-row--compact]': 'compact()',
    '[class.settings-row--disabled]': 'disabled()',
  },
})
export class SettingsRowCabinetComponent {
  readonly label = input.required<string>();
  readonly description = input<string>('');
  readonly layout = input<'inline' | 'stacked'>('inline');
  /** Tighter rows for long lists such as keyboard shortcuts. */
  readonly compact = input(false, { transform: booleanAttribute });
  /** Dims the label and description, for a setting that is switched off. */
  readonly disabled = input(false, { transform: booleanAttribute });
}
